import toString from './to-string';
var upperFirst = function (value) {
    var str = toString(value);
    return str.charAt(0).toUpperCase() + str.substring(1);
};
export default upperFirst;
//# sourceMappingURL=upper-first.js.map